module.exports = __webpack_public_path__ + "img/0-41.bc4719bf.jpg";